export default "__VITE_ASSET__CvwmMpg4__"